import React from 'react';
import {
	NavigationStepperComponentParams,
	NavigationStepperItemType,
} from '../../../../Components/Stepper/NavigationStepper';
import SubTabNavigationStepper from '../../../../Components/Stepper/SubTabNavigationStepper/SubTabNavigationStepper';
import ElectronicDPNList from '../../../Nczi/Components/ElectronicDPN/List/ElectronicDPNList';
import NCZIPatient from '../../../Nczi/Components/NCZIPatient/NCZIPatient';

interface Props {
	setIsLoading: (isLoading: boolean) => void;
}

const ElectronicDPN: React.FC<Props> = ({ setIsLoading }) => {
	const steps: NavigationStepperItemType[] = [
		{
			name: 'patientTreatment.electronicDPN.list.title',
			key: 'list',
			component: (params: NavigationStepperComponentParams) => (
				<NCZIPatient><ElectronicDPNList setIsLoading={setIsLoading} /></NCZIPatient>
			),
		},
	];

	return (
		<>
			<SubTabNavigationStepper
				steps={steps}
				initialStepPath='list'
				canSkip={true}
			/>
		</>
	);
};

export default ElectronicDPN;
